var SCM = SCM || {};

Date.prototype.MMddyyyy = function () {
    var month = this.getMonth() + 1;
    var date = this.getDate();
    var year = this.getFullYear();

    var monthStr = month;
    var dateStr = date;

    if (month < 10) {
        monthStr = '0' + month;
    }

    if (date < 10) {
        dateStr = '0' + date;
    }

    return monthStr + '/' + dateStr + '/' + year;
};

(function (ns, $) {
    
    var validationErrorInvalidYear = $('#hfValidationErrorInvalidYear').val();
    var validationErrorInvalidRange = $('#hfValidationErrorInvalidRange').val();

    // Get the date query to use in Solr as generated by the Publication Date Filter
    // If only we had a JS unit test framework...
    ns.getSolrDateString = function (fromYear, toYear, fromMonth, toMonth) {
        var fromDay = 1;
        var toDay = 0; // When constructing a Date in JavaScript, 0 gives the last day of the month.

        if (ns.isSingleDateSelected) {
            // Handle all single-date logic here. Note that only `fromMonth` and `fromYear` could have values.
            toYear = fromYear;

            if (!fromMonth) {
                fromMonth = 0;
                toMonth = 12;
            } else {
                toMonth = fromMonth;
                fromMonth -= 1;
            }

        } else {

            if (!fromYear && toYear) {
                fromYear = 1666;
                fromMonth = 0;
            }
            else if (fromYear && !toYear) {
                toYear = 2999;
                toMonth = 12;
            }

            if (!toMonth && fromYear && toYear) {
                toMonth = 12;
            }
        
            if (fromMonth) {
                fromMonth -= 1;
            }

        }

        var fromDate = new Date(fromYear, fromMonth, fromDay);
        var toDate = new Date(toYear, toMonth, toDay);

        return fromDate.MMddyyyy() + ' TO ' + toDate.MMddyyyy();
    };
    
    ns.getValidationResponseTextForDateRange = function (fromYear, toYear, fromMonth, toMonth) {
        // Years must be a 4-digit number. This rule takes precedence according to NARN-12955.
        if (!fromYear && !toYear ||
            fromYear && !/^[\d]{4}$/.test(fromYear) ||
            toYear && !/^[\d]{4}$/.test(toYear)) {
            return validationErrorInvalidYear;
        }

        // Cannot have invalid date ranges.
        if (fromYear && toYear && fromYear > toYear ||  // 1st case: cannot have 2020 to 2010.

            fromMonth && toMonth &&
                fromMonth > toMonth &&                  // 2nd case: cannot have July 2016 to January 2016.
            fromYear && toYear &&
                fromYear === toYear) {

            return validationErrorInvalidRange;
        }
    };

    ns.getValidationResponseTextForSingleDate = function (year) {
        // We will assume that either one of the year fields is filled when validating.

        // Years must be a 4-digit number. This rule takes precedence according to NARN-12955.
        if (!year || !/^[\d]{4}$/.test(year)) {
            return validationErrorInvalidYear;
        }
    };

    // Fill in the date filter values based on URL search parameters.
    ns.fillInMonthDropdown = function ($month, $year) {
        if ($month.length) {
            var selectedValue = $month.data('selected');
            if (selectedValue && $year.val()) {
                // If the month is filled in, fill it in!
                $month.val(selectedValue);
            }
        }
    };

    ns.isSingleDateSelected = false;

    ns.initDateRangeToggle = function () {
        $(document).on('click', '.js-date-range-input-radio', function () {
            ns.isSingleDateSelected = $(this).attr('value') === 'single';
            cacheInputs();
            if (ns.isSingleDateSelected) {
                $('.js-date-input-to').addClass('hide');
                $('.js-date-range-label').addClass('hide');
            } else {
                $('.js-date-input-to').removeClass('hide');
                $('.js-date-range-label').removeClass('hide');
            }
        });
    };
    
    // Date Range or Single Date
    ns.initDateFilterTypeToggle = function () {
        if (window.location.search.indexOf('dateFilterType=single') >= 0) {
            $('.js-date-range-input-radio[value="single"]').click();
        }
    };

    ns.$fromYear = null;
    ns.$toYear = null;
    ns.$fromMonth = null;
    ns.$toMonth = null;

    function cacheInputs() {
        ns.$fromYear = $('#fromYear');
        ns.$toYear = $('#toYear');
        ns.$fromMonth = $('#fromMonth');
        ns.$toMonth = $('#toMonth');
    }

    ns.init = function () {
        cacheInputs();

        ns.initDateRangeToggle();
        ns.initDateFilterTypeToggle();
        ns.fillInMonthDropdown(ns.$fromMonth, ns.$fromYear);
        ns.fillInMonthDropdown(ns.$toMonth, ns.$toYear);
    };

})(SCM.PublicationDateFilter = SCM.PublicationDateFilter || {}, jQuery);